import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotFoundComponent} from "./admin-core/components/not-found/not-found.component";
import {AuthGuardService} from "@coreservices";
import {NotificationsComponent} from './admin-core/components/notifications/notifications.component';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule), data: {hideHeader: true}, },
  { path: 'dashboard', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), canActivate: [AuthGuardService], pathMatch: 'full' },
  { path: 'accounts', loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsModule) },
  { path: 'contacts', loadChildren: () => import('./contacts/contacts.module').then(m => m.ContactsModule) },
  { path: 'sample-requests', loadChildren: () => import('./sample-requests/sample-requests.module').then(m => m.SampleRequestsModule) },
  { path: 'quotes', loadChildren: () => import('./quotes/quotes.module').then(m => m.QuotesModule) },
  { path: 'orders', loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule) },
  { path: 'products', loadChildren: () => import('./product/product.module').then(m => m.ProductModule) },
  { path: 'samples-fulfilment', loadComponent: () => import('./samples-fulfilment/samples-fulfilment.component').then(m => m.SamplesFulfilmentComponent), canActivate: [AuthGuardService] },
  { path: 'despatch', loadChildren: () => import('./despatch/despatch.module').then(m => m.DespatchModule) },
  { path: 'users', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
  { path: 'blogs', loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule) },
  { path: 'faq', loadChildren: () => import('./faq/faq.module').then(m => m.FaqModule) },
  { path: 'resource', loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule) },
  { path: 'projects', loadChildren: () => import('./projects/projects.module').then(m => m.ProjectsModule) },
  { path: 'carrier', loadChildren: () => import('./carriers/carriers.module').then(m => m.CarriersModule) },
  { path: 'supplier-management', loadChildren: () => import('./supplier-management/supplier-management.module').then(m => m.SupplierManagementModule) },
  { path: 'consumables-calculator', loadChildren: () => import('./consumables-calculator/consumables-calculator.module').then(m => m.ConsumablesCalculatorModule) },
  { path: 'task-categories', loadChildren: () => import('./task-categories/task-categories.module').then(m => m.TaskCategoriesModule) },
  { path: 'pebbl-feedback', loadChildren: () => import('./pebbl-feedback/pebbl-feedback.module').then(m => m.PebblFeedbackModule) },
  { path: 'pebbl-knowledge-feedback', loadChildren: () => import('./pebbl-feedback/pebbl-feedback.module').then(m => m.PebblFeedbackModule) },
  { path: 'email-templates', loadChildren: () => import('./email-template/email-template.module').then(m => m.EmailTemplateModule) },
  { path: 'tasks', loadChildren: () => import('./tasks/tasks.module').then(m => m.TasksModule)},
  { path: 'settings', loadChildren: () => import('./setting/setting.module').then(m => m.SettingModule)},
  // { path: 'pebbl-resources', loadChildren: () => import('./pebbl/pebbl.module').then(m => m.PebblModule) },
  // Guarded: the notifications page loads authenticated data as soon as it renders, so an expired
  // session must be turned away by the guard rather than by the 401 handler.
  {path: 'notifications', component: NotificationsComponent, canActivate: [AuthGuardService]},
  { path: 'stock-allocation', loadChildren: () => import('./stock-allocation/stock-allocation.module').then(m => m.StockAllocationModule) },
  { path: 'email', loadChildren: () => import('./email/email.module').then(m => m.EmailModule), canActivate: [AuthGuardService] },
  {path: 'ai', loadChildren: () => import('./ai/ai.module').then(m => m.AiModule)},
  // Route for the 404 component
  { path: '404', component: NotFoundComponent, data: {hideHeader: true} },
  // Wildcard route for unmatched routes
  { path: '**', redirectTo: '/404', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        /* 'disabled' hands the scroll policy to AppComponent, which scrolls to the
           top only when the PATH changes.

           'enabled' treated every navigation the same, and the record screens drive
           their section tabs off query params (`setTab()` in account-detail /
           contact-detail navigates with `queryParamsHandling: 'merge'`). So switching
           from Orders to Quotes on an account slammed the page back to the top even
           though the header and stats strip above had not moved.

           'disabled' does NOT stop the `Scroll` events — RouterScroller still records
           positions and emits them, it just stops acting on them itself — so
           back/forward restoration is preserved in AppComponent, and `anchorScrolling`
           below keeps working untouched. */
        scrollPositionRestoration: 'disabled',
        anchorScrolling: 'enabled',
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
